import React from 'react';
import styled from 'styled-components';
import useI18n from 'i18n';

import { ORDER_STATUS } from '.';
import { ReactComponent as DoneIcon } from '../../../Assets/Icons/check_white.svg';

const StatusColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: 15% 0 20%;
`;

const StatusRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StatusText = styled.h5`
  font-family: Eina 01;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 114%;
`;

const Circle = styled.div<{ checked: boolean }>`
  height: 32px;
  width: 32px;
  border: 1px solid #ddd;
  border-radius: 24px;
  padding: 4px;
  background-color: ${({ checked }) => (checked ? '#209946' : '')};
  margin-right: 16px;
`;

const Divider = styled.div`
  width: 1px;
  height: 24px;
  background: #e0e0e3;
  margin-left: 15px;
`;

interface Props {
  status: ORDER_STATUS;
}

const OrderStatusDisplay = ({ status }: Props) => {
  const { i18n } = useI18n();
  const accepted = Boolean(status === ORDER_STATUS.ACCEPTED);
  const finalizing = Boolean(status === ORDER_STATUS.FINALIZING);
  const ready = Boolean(status === ORDER_STATUS.READY);
  return (
    <StatusColumn>
      <StatusRow>
        <Circle checked={accepted || finalizing || ready}>
          {(accepted || finalizing || ready) && <DoneIcon />}
        </Circle>
        <StatusText>{i18n('Receipt.Accepted')}</StatusText>
      </StatusRow>
      <Divider />
      <StatusRow>
        <Circle checked={finalizing || ready}>{(finalizing || ready) && <DoneIcon />}</Circle>
        <StatusText>{i18n('Receipt.Finalizing')}</StatusText>
      </StatusRow>
      <Divider />
      <StatusRow>
        <Circle checked={ready}>{ready && <DoneIcon />}</Circle>
        <StatusText>{i18n('Receipt.Ready')}</StatusText>
      </StatusRow>
    </StatusColumn>
  );
};

export default OrderStatusDisplay;
